import request from '@/utils/request'

//获取商品列表
export function invoiceInventory(data) {
  return request({
    url: 'api/v1/invoice/invoiceInventory',
    method: 'post',
    data
  })
}

//申领准备信息查询
export function applyInvoiceInfo(data) {
  return request({
    url: 'api/v1/invoice/applyInvoiceInfo',
    method: 'post',
    data
  })
}

//发票申领状态查询
export function applyInvoiceStatus(data) {
  return request({
    url: 'api/v1/invoice/applyInvoiceStatus',
    method: 'post',
    data
  })
}

//撤销网上申领
export function cancelApplyInvoice(data) {
  return request({
    url: 'api/v1/invoice/cancelApplyInvoice',
    method: 'post',
    data
  })
}


//纸质票接收确认
export function applyInvoiceQz(data) {
  return request({
    url: 'api/v1/invoice/applyInvoiceQz',
    method: 'post',
    data
  })
}

//发票申领
export function applyInvoice(data) {
  return request({
    url: 'api/v1/invoice/applyInvoice',
    method: 'post',
    data
  })
}

//查询当前未开票号 用于作废空白发票
export function notOpenInvoice(data) {
  return request({
    url: 'api/v1/invoice/notOpenInvoice',
    method: 'post',
    data
  })
}

//红字信息表申请
export function applyRedInfo(data) {
  return request({
    url: 'api/v1/invoice/applyRedInfo',
    method: 'post',
    data
  })
}

//红字信息表查询 更新信息
export function getApplyRedSpeed(data) {
  return request({
    url: 'api/v1/invoice/getApplyRedSpeed',
    method: 'post',
    data
  })
}

//红字信息表list
export function redList(data) {
  return request({
    url: 'api/v1/invoice/redList',
    method: 'post',
    data
  })
}

//红字信息表撤销
export function cancelRed(data) {
  return request({
    url: 'api/v1/invoice/cancelRed',
    method: 'post',
    data
  })
}

//红字发票下载
export function redDownLoad(data) {
  return request({
    url: 'api/v1/invoice/redDownLoad',
    method: 'post',
    data
  })
}

//红字发票详情
export function redInfo(data) {
  return request({
    url: 'api/v1/invoice/redInfo',
    method: 'post',
    data
  })
}

//发票带分发列表
export function applyFpList(data) {
  return request({
    url: 'api/v1/invoice/applyFpList',
    method: 'post',
    data
  })
}

//发票分发
export function applyDistribute(data) {
  return request({
    url: 'api/v1/invoice/applyDistribute',
    method: 'post',
    data
  })
}

//打印
export function getInvoicePrintInfo(data) {
  return request({
    url: 'api/v1/invoice/getInvoicePrintInfo',
    method: 'post',
    data
  })
}